import React from 'react';
import PropTypes from 'prop-types';

import Input from 'dpl/form/components/Input';

export default function SocialLinkQuestion({ name, title, placeholder }) {
  return (
    <div className="SocialLinkQuestion">
      <Input
        name={name}
        label={title}
        placeholder={placeholder}
        displayErrors
      />
    </div>
  );
}

SocialLinkQuestion.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  placeholder: PropTypes.string.isRequired
};

SocialLinkQuestion.defaultProps = {
  title: null
};
